import React from 'react';

import ItemCategoriesPage from 'pages/itemCategories/ItemCategoriesPage';
import MandatoryKpisPage from 'pages/mandatoryKpis/MandatoryKpisPage';
import ReductionActionsPage from 'pages/reductionActions/ReductionActionsPage';

import CertificatesPage from './pages/certificates/CertificatesPage';
import Co2SimulatorPage from './pages/co2Simulator/Co2SimulatorPage';
import CompaniesPage from './pages/companies/CompaniesPage';
import CountriesPage from './pages/countries/CountriesPage';
import DeviationsPage from './pages/deviations/DeviationsPage';
import DocumentsPage from './pages/documents/DocumentsPage';
import GoodPracticesPage from './pages/goodPractices/GoodPracticesPage';
import LanguagesPage from './pages/languages/LanguagesPage';
import LoginPage from './pages/login/LoginPage';
import MaterialsPage from './pages/materials/MaterialsPage';
import NewDashboardPage from './pages/newDashboard/NewDashboardPage';
import PlasticAssessmentPage from './pages/plasticAssessment/PlasticAssessmentPage';
import PlasticAssessmentsPage from './pages/plasticAssessments/PlasticAssessmentsPage';
import ResetPasswordPage from './pages/resetPassword/ResetPasswordPage';
import TranslationPage from './pages/translation/TranslationPage';
// import UnitOfMeasuresPage from './pages/unitOfMeasures/UnitOfMeasuresPage';
import UsersPage from './pages/users/UsersPage';
import Img1 from './sidebar_images/img1.png';
import Img2 from './sidebar_images/img2.png';
import Img3 from './sidebar_images/img3.png';
import Img4 from './sidebar_images/img4.png';
import Img5 from './sidebar_images/img5.png';
import Img6 from './sidebar_images/img6.png';
import Img7 from './sidebar_images/img7.png';
import Route from './types/Route';

const routes: Route[] = [
    {
        name: 'pages.dashboard.title',
        path: '/',
        component: <NewDashboardPage />,
        roles: ['customer'],
        image: Img1
    },
    {
        name: 'pages.companies.title',
        path: '/companies',
        component: <CompaniesPage />,
        roles: ['admin', 'auditor', 'certifier']
    },
    {
        name: 'pages.users.title',
        path: '/users',
        component: <UsersPage />,
        roles: ['admin', 'certifier']
    },
    {
        name: 'pages.public_documents.title',
        path: '/public-documents',
        exactPathSidebar: false,
        component: <DocumentsPage publicPage />,
        roles: ['customer', 'admin', 'certifier', 'auditor'],
        image: Img2
    },
    {
        name: 'pages.admin_public_good_practices.title',
        path: '/gps',
        component: <GoodPracticesPage publicPage adminPage />,
        roles: ['admin']
    },
    {
        name: 'pages.deviations.title',
        path: '/deviations',
        component: <DeviationsPage />,
        roles: ['admin']
    },
    {
        name: 'pages.mandatory_kpis.title',
        path: '/mandatory-kpis',
        component: <MandatoryKpisPage />,
        roles: ['admin']
    },
    /*
    {
        name: 'pages.unit_of_measures.title',
        path: '/unit-of-measures',
        component: <UnitOfMeasuresPage />,
        roles: ['admin']
    },
    */
    {
        name: 'pages.materials.title',
        path: '/materials',
        component: <MaterialsPage />,
        roles: ['admin']
    },
    {
        name: 'pages.item_categories.title',
        path: '/item_categories',
        component: <ItemCategoriesPage />,
        roles: ['admin']
    },
    {
        name: 'pages.reduction_actions.title',
        path: '/reduction-actions',
        component: <ReductionActionsPage />,
        roles: ['admin']
    },
    {
        name: 'pages.countries.title',
        path: '/countries',
        component: <CountriesPage />,
        roles: ['admin']
    },
    {
        name: 'pages.languages.title',
        path: '/languages',
        exactPathSidebar: false,
        component: <LanguagesPage />,
        roles: ['admin']
    },
    {
        path: '/languages/:id',
        showInSidebar: false,
        component: <TranslationPage />,
        roles: ['admin']
    },
    {
        name: 'pages.plastic_assessments.title',
        path: '/plastic-assessments',
        exactPathSidebar: false,
        component: <PlasticAssessmentsPage />,
        roles: ['customer'],
        image: Img3
    },
    {
        path: '/companies/:companyId/plastic-assessments',
        showInSidebar: false,
        component: <PlasticAssessmentsPage />,
        roles: ['admin', 'auditor', 'certifier']
    },
    {
        path: '/plastic-assessments/:id',
        exactPath: false,
        showInSidebar: false,
        component: <PlasticAssessmentPage />,
        roles: ['customer']
    },
    {
        path: '/companies/:companyId/plastic-assessments/:id',
        exactPath: false,
        showInSidebar: false,
        component: <PlasticAssessmentPage companyPrefix />,
        roles: ['admin', 'auditor', 'certifier']
    },
    {
        path: '/companies/:companyId/documents',
        showInSidebar: false,
        component: <DocumentsPage />,
        roles: ['admin', 'auditor', 'certifier']
    },
    {
        name: 'pages.documents.title',
        path: '/documents',
        component: <DocumentsPage />,
        roles: ['customer'],
        image: Img4
    },
    {
        path: '/companies/:companyId/certificates',
        showInSidebar: false,
        component: <CertificatesPage />,
        roles: ['admin', 'auditor', 'certifier']
    },
    {
        name: 'pages.certificates.title',
        path: '/certificates',
        component: <CertificatesPage />,
        roles: ['customer'],
        image: Img5
    },
    {
        path: '/companies/:companyId/gps',
        showInSidebar: false,
        component: <GoodPracticesPage />,
        roles: ['admin']
    },
    {
        name: 'pages.public_good_practices.title',
        path: '/gps',
        component: <GoodPracticesPage publicPage />,
        roles: [],
        image: Img6
    },
    {
        name: 'pages.co2_external_tool.menu_title',
        path: '/co2-simulator',
        component: <Co2SimulatorPage />,
        roles: ['customer', 'certifier', 'auditor'],
        image: Img7
    },
    {
        name: 'pages.login.title',
        path: '/login',
        exactPath: false,
        showSidebar: false,
        showInSidebar: false,
        requireAuth: false,
        canAuth: false,
        component: <LoginPage />
    },
    {
        name: 'pages.reset_password.title',
        path: '/reset-password/:token',
        exactPath: false,
        showSidebar: false,
        showInSidebar: false,
        requireAuth: false,
        canAuth: false,
        component: <ResetPasswordPage />
    }
];

const defaultAttributes: Partial<Route> = {
    exactPath: true,
    exactPathSidebar: true,
    showSidebar: true,
    showInSidebar: true,
    requireAuth: true,
    canAuth: true
};

const finalRoutes = routes.map(route => {
    // default attributes and real attributes are merged
    return { ...defaultAttributes, ...route };
});

export default finalRoutes;
